import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ListQuote, Quote, QuoteCalculationStatus } from "../../types/Quote";

type SetQuoteCalculationStatusOverridePayload = {
  quoteId: string;
  dossierId: string;
  calculationStatus: QuoteCalculationStatus;
};

export const setQuoteCalculationStatusOverride = (
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    optimisiticUpdateOnMutate,
    getDataByQueryKey,
  } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: SetQuoteCalculationStatusOverridePayload
    ): Promise<boolean> => {
      return fetchWithAuth<boolean>(
        "setQuoteCalculationStatusOverride",
        payload.quoteId,
        {
          requestOptions: { method: "post", body: JSON.stringify(payload) },
        }
      );
    },
    onMutate: async (payload) => {
      // Update Quotes
      const quotesQueryKey = ["quotes", payload.dossierId];
      const quotes = getDataByQueryKey(quotesQueryKey) as ListQuote[];

      if (quotes) {
        const quoteIndex = quotes.findIndex(
          (quote) => quote.identifiers.crmQuoteId === payload.quoteId
        );
        const quoteToUpdate = quotes[quoteIndex];
        const updatedQuotes = [...quotes];
        updatedQuotes[quoteIndex] = {
          ...quoteToUpdate,
          config: {
            ...quoteToUpdate.config,
            calculationStatus: payload.calculationStatus,
          },
        };

        optimisiticUpdateOnMutate(quotesQueryKey, updatedQuotes);
      }

      // Update Quote
      const quoteQueryKey = ["quote", payload.quoteId];
      const quote = getDataByQueryKey(quoteQueryKey) as Quote;

      if (quote) {
        optimisiticUpdateOnMutate(quoteQueryKey, {
          ...quote,
          config: {
            ...quote.config,
            calculationStatus: payload.calculationStatus,
          },
        });
      }
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
